export default __webpack_public_path__ + "static/media/the-outsiders.1d74d10c.jpg";